export const g_defaultNcode = {
    section: 0,
    owner: 27,
    book: 667,
    page: 1, // 0
};
export const g_defaultTemporaryNcode = {
    section: 0,
    owner: 27,
    book: 667,
    page: 1, // 1
};
export const g_defaultOverlayNcode = {
    section: 4094,
    owner: 0,
    book: 0,
    page: 0, // 1
};
//# sourceMappingURL=MapperConstants.js.map